const SOCIAL_ACCT_LIMIT_MESG = {
    DEFAULT: 'You have reached User(s) limit in your subscription. To add more, you may upgrade your subscription',
    USER_LIMIT: 'You have reached User(s) limit in your subscription. To add more'
}


const TEAM_MANAG_NOT_AVAIL= 'You do not have access to Team Management module in your subscription. To access Team Management, you may Upgrade your subscription.';


export { SOCIAL_ACCT_LIMIT_MESG, TEAM_MANAG_NOT_AVAIL };